import { t } from '@lingui/core/macro';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { participantProjectsControllerHideProject } from '@/api/core-api';
import { notify } from '@/components/base/notifications/notifications';

import { queryKeys } from './query-keys';

export function useHideProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (projectId: string) => {
      const response = await participantProjectsControllerHideProject({
        path: { id: projectId },
      });

      if (response.error || !response.data?.success) {
        throw new Error(response.data?.message ?? t`Failed to hide project`);
      }

      return response.data;
    },
    onSuccess: () => {
      // Invalidate matched projects to refetch without the hidden project
      void queryClient.invalidateQueries({
        queryKey: queryKeys.projects.matchedBase,
      });
    },
    onError: (error) => {
      notify({
        title: t`Failed to hide project`,
        description: error.message,
        color: 'error',
      });
    },
  });
}
